import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from '../config';
import ServiceCard from '../components/ServiceCard';
import './Services.css';

export default function Services() {
  const [services, setServices] = useState(null);
  const [page, setPage] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/services`)
      .then((r) => (r.ok ? r.json() : []))
      .then(setServices)
      .catch(() => setServices([]));
    fetch(`${API_BASE_URL}/api/homepage`)
      .then((r) => (r.ok ? r.json() : null))
      .then(setPage)
      .catch(() => {});
  }, []);

  const title = page?.servicesPageTitle || 'Services';
  const lead = page?.servicesPageLead || 'Therapeutic massage and bodywork — tailored to what your body needs today.';

  if (services === null) {
    return (
      <main className="services-main">
        <div className="services-loading">Loading...</div>
      </main>
    );
  }

  return (
    <main className="services-main">
      <header className="services-header">
        <h1>{title}</h1>
        <p className="services-lead">{lead}</p>
      </header>
      {services.length === 0 ? (
        <p className="services-empty">
          Services are being prepared — please <a href="/contact">get in touch</a> for availability.
        </p>
      ) : (
        <div className="service-grid">
          {services.map((s) => (
            <ServiceCard key={s.id} service={s} />
          ))}
        </div>
      )}
    </main>
  );
}
